import * as React from 'react';
import { Box, Container, Typography, Grid, Link, Divider } from '@mui/material';
import { Phone, Email, LocationOn } from '@mui/icons-material';
import imgLogo from '../assets/png/nopala_logo.png';
import { usePermissions } from '../hooks/usePermission';


export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { user, canViewInventory, canViewPart, canViewProperty,
          canViewArea, canViewBuilding, canViewAsignSafe } = usePermissions();
  const isAuthenticated = !!user;
  
  return (
    <>
      <Box
        component="footer"
        position="static"
        sx={{
          background: 'linear-gradient(180deg, #3b1e1eff -10%, #833c3cff 80%)',
          backdropFilter: 'blur(10px)',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          color: 'white',
          py: 6,
          mt: 5
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4} sx={{ mb: 4 }}>
            {/* SECCION: LOGO Y DESCRIPCION */}
            <Grid item xs={12} sm={6} md={3}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: { xs: 'center', sm: 'flex-start' },
                  gap: 2,
                }}
              >
                <Box
                  component="img"
                  src={imgLogo}
                  alt="Logo Nopala"
                  sx={{
                    height: 50,
                    width: 'auto',
                    filter: 'drop-shadow(0 0 8px rgba(255, 255, 255, 0.8))',
                    transition: 'transform 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.05)',
                    },
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: '#e0e7ff',
                    textAlign: { xs: 'center', sm: 'left' },
                    fontSize: '0.9rem',
                    lineHeight: 1.6,
                  }}
                >
                 Sistema de Inventarios Municipal
                </Typography>
              </Box>
            </Grid>

            {/* SECCION: ENLACES RAPIDOS */}
            {isAuthenticated && (
              <Grid item xs={12} sm={6} md={3}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    mb: 2,
                    fontSize: '1rem',
                    textShadow: '0 1px 3px rgba(0,0,0,0.5)',
                  }}
                >
                  Enlaces Rápidos
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {[
                    { label: "Inventarios", href: "/inventory", canView: canViewInventory },
                    { label: "Resguardos", href: "/asign-safe", canView: canViewAsignSafe },
                    { label: "Partidas", href: "/part", canView: canViewPart },
                    { label: "Bienes", href: "/property", canView: canViewProperty },
                    { label: "Áreas", href: "/area", canView: canViewArea },
                    { label: "Edificios", href: "/building", canView: canViewBuilding }
                  ].filter(item => item.canView)
                    .map(item => (
                      <Link
                        key={item.label}
                        href={item.href}
                        sx={{
                          color: '#e0e7ff',
                          textDecoration: 'none',
                          fontSize: '0.95rem',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            color: 'white',
                            ml: 1,
                            textShadow: '0 0 8px rgba(255, 255, 255, 0.5)',
                          },
                        }}
                      >
                        {item.label}
                      </Link>
                    ))}
                </Box>
              </Grid>
            )}
            {/* SECCION: INFORMACION */}
            {/* <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 'bold',
                  mb: 2,
                  fontSize: '1rem',
                  textShadow: '0 1px 3px rgba(0,0,0,0.5)',
                }}
              >
                Información
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {[
                  {label:'Términos de Servicio', href: "#"},
                  {label: 'Política de Privacidad', href: "#"},
                  {label: 'Ayuda', href: "#"},
                  {label: 'Contacto', href: "#"}
                ].map((item) => (
                  <Link
                    key={item.label}
                    href={item.href}
                    sx={{
                      color: '#e0e7ff',
                      textDecoration: 'none',
                      fontSize: '0.95rem',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        color: 'white',
                        ml: 1,
                        textShadow: '0 0 8px rgba(255, 255, 255, 0.5)',
                      },
                    }}
                  >
                    {item.label}
                  </Link>
                ))}
              </Box>
            </Grid> */}

            {/* SECCION: CONTACTO */}
            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 'bold',
                  mb: 2,
                  fontSize: '1rem',
                  textShadow: '0 1px 3px rgba(0,0,0,0.5)',
                }}
              >
                Contacto
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Phone
                    sx={{
                      fontSize: 18,
                      color: '#e0e7ff',
                    }}
                  />
                  <Link
                    href="tel:+1234567890"
                    sx={{
                      color: '#e0e7ff',
                      textDecoration: 'none',
                      fontSize: '0.95rem',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        color: 'white',
                        textShadow: '0 0 8px rgba(255, 255, 255, 0.5)',
                      },
                    }}
                  >
                    +52 761 782 1065
                  </Link>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Email
                    sx={{
                      fontSize: 18,
                      color: '#e0e7ff',
                    }}
                  />
                  <Link
                    href="mailto:info@nopala.com"
                    sx={{
                      color: '#e0e7ff',
                      textDecoration: 'none',
                      fontSize: '0.95rem',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        color: 'white',
                        textShadow: '0 0 8px rgba(255, 255, 255, 0.5)',
                      },
                    }}
                  >
                    laura.zamudio@nopaladevillagran.com.mx
                  </Link>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                  <LocationOn
                    sx={{
                      fontSize: 18,
                      color: '#e0e7ff',
                      mt: 0.3,
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#e0e7ff',
                      fontSize: '0.95rem',
                      lineHeight: 1.4,
                    }}
                  >
                    Palacio Municipal, S/N, Col. Centro<br/>
                    C.P. 42470, Nopala de Villagrán, Hgo.
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>

          {/* DIVISOR */}
          <Divider
            sx={{
              my: 3,
              borderColor: 'rgba(255, 255, 255, 0.1)',
            }}
          />

          {/* FOOTER INFERIOR */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                margin:'auto',
                color: '#b8bed1',
                fontSize: '0.9rem',
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              © {currentYear} Nopala de Villagrán - Todos los derechos reservados.
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* KEYFRAMES PARA ANIMACIONES */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
}
